import { useClerk, useUser } from '@clerk/nextjs';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface Props {
  redirectTo: string;
}

export const useEnsureProviderAuth = ({ redirectTo }: Props) => {
  const router = useRouter();
  const [error, setError] = useState('');
  const { signOut } = useClerk();
  const { user } = useUser();

  useEffect(() => {
    // Check if the user should be signed out
    const checkUserAuthorization = async () => {
      if (user) {
        // If the user does not have the required metadata or authorization
        const isAuthorized = user.publicMetadata?.healthie_user_id;

        if (!isAuthorized) {
          setError('Your account is restricted. Please contact support.');
          await signOut();

          router.push(redirectTo);
        }
      }
    };

    checkUserAuthorization();
  }, [user, signOut]);

  return { user, error };
};
